<template>
  <div class="exchangeSidebar">
    <ScDataListIterator
      :content-title="translations.orderSummaryHeading"
      :items="getOrderCostSummaryItems"
    />
    <slot name="footer" />
  </div>
</template>

<script src="./index.js"></script>

<style lang="scss">
@import './style.scss';
</style>
